export default __webpack_public_path__ + "static/media/closeButton.cfccae79.svg";